module.exports = __webpack_public_path__ + "static/missinglabel-peek-f995822cdf7f761db037fee77c10b5d5.png";